/** DEFAULT **/

const addDefaultAdditionalOptions = (schema, formData, intl, position = 0) => {
  let pos = position;

  return pos;
};

export default addDefaultAdditionalOptions;
